// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Button, Modal } from '@imprivata-cloud/components';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './DisableOidcConfirmationModal.less';

interface DisableOidcConfirmationModalProps {
  open: boolean;
  isDeleting: boolean;
  onDisable: () => void;
  onCancel: () => void;
}

const TRANSLATION_ROOT = 'apps.oidc.disable-modal';

const DisableOidcConfirmationModal: React.FC<DisableOidcConfirmationModalProps> = ({
  open,
  isDeleting,
  onDisable,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={null}
      open={open}
      className="disable-oidc-modal"
      width={428}
      closable={false}
      footer={null}
      maskClosable={false}
      onCancel={onCancel}
      destroyOnHidden
    >
      <div className="disable-oidc-modal-body">
        <HelpCircle className="disable-oidc-modal-icon" size={64} strokeWidth={2} />
        <h2 className="disable-oidc-modal-title">{t(`${TRANSLATION_ROOT}.title`)}</h2>
        <p className="disable-oidc-modal-content">{t(`${TRANSLATION_ROOT}.body`)}</p>
        <div className="disable-oidc-modal-footer">
          <Button
            type="default"
            label={t(`${TRANSLATION_ROOT}.confirm`)}
            onClick={onDisable}
            disabled={isDeleting}
            className="disable-oidc-modal-disable-button"
          />
          <Button
            type="primary"
            label={t(`${TRANSLATION_ROOT}.cancel`)}
            onClick={onCancel}
            disabled={isDeleting}
            className="disable-oidc-modal-cancel-button"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DisableOidcConfirmationModal;
